<template>
  <auth-frame wide>
    <enable-google-2fa
      v-if="created"
      :description="tr('The use of two-factor authentication is mandatory in the account.') + '<br/><br/>'"
      @success="() => onSuccess()"
      @cancel="() => logout()"
    />
  </auth-frame>
</template>

<script>
import AuthFrame from '@/ui/components/AuthFrame.vue';
import EnableGoogle2fa from '@/ui/components/EnableGoogle2fa.vue';

export default {
  name: 'Enable2faView',
  components: {
    AuthFrame,
    EnableGoogle2fa,
  },
  data:() => ({
    created: false,
  }),
  created() {
    if (this.$root.loggedInUser && this.$root.loggedInUser.google_2fa_enabled) {
      this.$router.replace('/');
      return;
    }

    this.created = true;
  },
  methods: {
    onSuccess() {
      this.$router.replace('/');
      window.location.reload();
    },
    logout() {
      this.$store.dispatch('auth/logout');
    },
  },
};
</script>
